export const removeUndefined = (value) => {
  Object.keys(value).forEach((key) => (value[key] === undefined ? delete value[key] : {}))
  return value
}

export const isValidArray = (array) => {
  return Array.isArray(array) && array?.length > 0
}
